import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, User, RootState } from '../../types';
import type { UserCardAccount } from '../../types/models/user';
import { apiListGetUserByToken } from '../../api/userApi';

// Inizializzazione asincrona dello stato (nota: questo pattern andrebbe sostituito con un async thunk)
const userLoggedState = await apiListGetUserByToken();

const initialState: AuthState = {
  isAuthenticated: false,
  userLoggedState: userLoggedState?.username ? userLoggedState : null,
  user: userLoggedState?.username ? userLoggedState : null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.userLoggedState = action.payload;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userLoggedState = null;
      state.user = null;
    },
    updateCardAccount: (state, action: PayloadAction<UserCardAccount | null>) => {
      if (state.user) state.user = { ...state.user, card_account: action.payload };
      if (state.userLoggedState) state.userLoggedState = { ...state.userLoggedState, card_account: action.payload };
    },
  },
});

export const { login, logout, updateCardAccount } = authSlice.actions;
export const selectAuth = (state: RootState): AuthState => state.auth;
export default authSlice.reducer;
